export const IS_DEBUG = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

export const CHANNEL_TALK_CHANNEL_ID = '98195'

export const AGENT_POLLING_INTERVAL_MS = 20000
export const AGENT_LIST_PAGE_SIZE = 20
export const CONTROL_ROOM_REQUESTING_POLLING_INTERVAL_MS = 20000
export const CONTROL_ROOM_SUMMARY_POLLING_INTERVAL_MS = 30000
export const CONTROL_ROOM_NOTIFICATION_POLLING_INTERVAL_MS = 30000
